import React, { useEffect, useRef } from "react";

const bubble = (role, size) =>
  `max-w-[85%] ${size} leading-relaxed whitespace-pre-wrap ${role === "user" ? "bg-[#C49A6C] text-[#0B0A08]" : "bg-[#141311] border border-[#262421] text-[#F2EBE1]"}`;

export const ChatMessages = ({ messages, sending, intro, thinking, testPrefix, dir, className, size = "px-3.5 py-2.5 text-sm" }) => {
  const ref = useRef(null);
  useEffect(() => { if (ref.current) ref.current.scrollTop = ref.current.scrollHeight; }, [messages, sending]);
  return (
    <div ref={ref} dir={dir} className={className}>
      {messages.length === 0 && <div className="text-sm text-[#8A857D] leading-relaxed bg-[#141311] border border-[#262421] p-3">{intro}</div>}
      {messages.map((m) => (
        <div key={m.id} className={`flex ${m.role === "user" ? "justify-end" : "justify-start"}`}>
          <div data-testid={`${testPrefix}-msg-${m.role}`} className={bubble(m.role, size)}>{m.content}</div>
        </div>
      ))}
      {sending && <div className="flex justify-start"><div className="bg-[#141311] border border-[#262421] text-[#8A857D] px-3.5 py-2.5 text-sm italic">{thinking}</div></div>}
    </div>
  );
};

export const ChatInput = ({ value, onChange, onSend, disabled, placeholder, dir, testPrefix, children, inputClass }) => (
  <div className="border-t border-[#262421] p-3 flex items-end gap-2">
    <textarea
      dir={dir} value={value} onChange={(e) => onChange(e.target.value)} rows={1}
      onKeyDown={(e) => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); onSend(); } }}
      data-testid={`${testPrefix}-input`} placeholder={placeholder}
      className={`flex-1 bg-[#0B0A08] border border-[#262421] text-sm text-[#F2EBE1] placeholder:text-[#6E685F] outline-none focus:border-[#C49A6C] resize-none ${inputClass}`}
    />
    <button onClick={onSend} disabled={disabled} data-testid={`${testPrefix}-send`} className="shrink-0 flex items-center gap-2 bg-[#C49A6C] text-[#0B0A08] hover:bg-[#E7CBA9] transition-colors disabled:opacity-40">
      {children}
    </button>
  </div>
);
